import { useState } from 'react';

import { gql, useQuery } from '@apollo/client';

export const GET_CHANGELOGS = gql`
  query getChangelogs($projectId: String!, $queryOptions: QueryOptionsInput!) {
    getChangelogs(projectId: $projectId, queryOptions: $queryOptions) {
      collection {
        _id
        actionType
        relationsObjects
        timeStripeName
        taskName
        createdAt
        createdBy
        createdByAccount {
          profile {
            displayName
          }
        }
      }
      totalCount
    }
  }
`;

export const useGetChangelogs = (projectId: string) => {
  const [currentPage, setPage] = useState(1);

  const pageSize = 12;
  const { data, loading } = useQuery(GET_CHANGELOGS, {
    variables: {
      queryOptions: {
        limit: pageSize,
        skip: pageSize * currentPage - pageSize,
      },
      projectId,
    },
    fetchPolicy: 'network-only',
  });

  const { totalCount = 0, collection = [] } = data?.getChangelogs || {};

  return {
    loading,
    changelogs: collection,
    paginationConfig: {
      total: totalCount,
      pageSize,
      current: currentPage,
      onChange: (page: number) => setPage(page),
    },
  };
};
